module.exports = __webpack_public_path__ + "static/media/257-sardinia.8814f8b5.svg";